import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment/moment';
import { License } from 'src/app/models/licenses-model/license.model';

@Component({
  selector: 'app-licenses-license-resume-card',
  templateUrl: './licenses-license-resume-card.component.html',
  styleUrls: ['./licenses-license-resume-card.component.scss']
})
export class LicensesLicenseResumeCardComponent implements OnInit {

  @Input() license: License;
  expanded = false;

  constructor() { }

  ngOnInit() {
  }

  public getColor(license: License) {
    const time: number = new Date().getTime();
    if (license.StartDate === 0 && license.EndDate === 0) {
      return 'ribbon-green';
    } else if ( time < license.StartDate || time > license.EndDate) {
      return 'ribbon-red';
    } else if ( (license.EndDate - time) / 1000 <= 864000) { // 10 days (in secs) to expire
      return 'ribbon-yellow';
    }
  }

  public toggleDevices(e) {
    e.stopPropagation();
    if (this.hasDevices()) {
      this.expanded = !this.expanded;
    }
  }

  public hasDevices() {
    return this.getDevices().length > 0;
  }

  public getDevices() {
    if (!this.license) {
      return [];
    }
    return this.license.DeviceList ? this.license.DeviceList : [];
  }

  public isToday(date) {
    return moment().startOf('day').valueOf() < date && date < moment().endOf('day').valueOf();
  }
}
